module.exports = __webpack_public_path__ + "img/manufacture.4c45c8c.jpg";